export default class TranslationLabelsCacheName {
  static getLibelleList(): string {
    return "labelList";
  }
}
